<div class="chat-input-field">
  <input
    class="chat-text-input"
    type="text"
    [placeholder]="'app.components.parentAiAssistant.placeholder' | translate"
    [value]="message()"
    (input)="messageChange.emit($any($event.target).value)"
    (keydown.enter)="onEnterKey($event)"
  />
  <div class="chat-input-actions">
    @if (showSpeechToText()) {
      <button
        type="button"
        class="action-btn mic-btn"
        [class.transcribing]="isTranscribing()"
        [class.listening]="isRecording()"
        [disabled]="isTranscribing()"
        (click)="toggleSpeechToText.emit()"
        [attr.aria-label]="
          isRecording()
            ? ('app.components.parentAiAssistant.stopRecording' | translate)
            : ('app.components.parentAiAssistant.speechToText' | translate)
        "
      >
        <img src="/public/svgs/mic.svg" alt="" aria-hidden="true" />
        @if (isTranscribing()) {
          <span class="mic-status-dot" aria-hidden="true"></span>
        }
      </button>
    }
    <button
      type="button"
      class="action-btn send-btn"
      [disabled]="!message().trim()"
      (click)="send.emit()"
      [attr.aria-label]="'app.components.parentAiAssistant.send' | translate"
    >
      <img src="/public/svgs/send.svg" alt="" aria-hidden="true" />
    </button>
  </div>
</div>
